import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RakutenRoutingModule } from './rakuten-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { SharedModule } from '../shared/shared.module';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { RakutenSearchFilterComponent } from './components/rakuten-search/components/rakuten-search-filter';
import { RakutenCategoriesComponent } from './components/rakuten-categories';
import { RakutenItemComponent } from './components/rakuten-item';
import { RakutenSearchComponent } from './components/rakuten-search';

@NgModule({
  declarations: [
    RakutenSearchFilterComponent,
    RakutenCategoriesComponent,
    RakutenItemComponent,
    RakutenSearchComponent,
  ],
  imports: [
    CommonModule,
    RakutenRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NzImageModule,
    NzGridModule,
    NzListModule,
    NzButtonModule,
    NzCardModule,
    NzLayoutModule,
    NzPaginationModule,
    NzInputModule,
    NzEmptyModule,
    NzTableModule,
    TranslateModule,
    NzDescriptionsModule,
    NzPopconfirmModule,
    NzSelectModule,
    NzSpinModule,
    NzRadioModule,
    SharedModule,
    NzCollapseModule,
    NzBreadCrumbModule,
    NzCheckboxModule,
    NzSwitchModule,
    NzRateModule,
    NzFormModule,
    NzInputNumberModule,
  ],
})
export class RakutenModule {}
